export interface ChartModel {
  key: string;
  value: number;
}
